// extracted by mini-css-extract-plugin
export default {"Information":"InformationCard_Information__tphhB","Content":"InformationCard_Content__nYoQN","Link":"InformationCard_Link__W0twz"};